import Carousel from "@/components/common/Carousel";
import Wrapper from "@/components/site-builder/BaseModule/Wrapper";
import { getRotationSettings } from "@/components/site-builder/ColumnCarousel/utils";
import { SiteBuilderMultiColumnModuleRotation } from "@/constants/site-builder";
import type { HeroCarouselModuleType } from "./types";
import s from "./HeroCarouselModule.module.scss";
import Mapper from "./Mapper";

const carouselSettingsOverride = {
  spaceBetween: 0,
  breakpoints: {},
};

export interface HeroCarouselModuleProps {
  module: HeroCarouselModuleType;
}

export default function HeroCarouselModule(props: HeroCarouselModuleProps) {
  const { module } = props;
  const {
    style: {
      display: { contentLayout, rotation },
    },
    body: { blocks },
  } = module;

  const carouselSettings = {
    ...getRotationSettings(rotation, contentLayout.split(":").length),
    ...carouselSettingsOverride,
  };

  return (
    <Wrapper module={module} className={s.wrapper}>
      <Carousel
        items={blocks}
        renderItem={(block) => <Mapper module={module} block={block} />}
        settings={carouselSettings}
        fullScreen
        smoothScrolling={
          rotation === SiteBuilderMultiColumnModuleRotation.Smooth
        }
      />
    </Wrapper>
  );
}
